export default __webpack_public_path__ + "static/media/zfmexico.56355007.png";